// App.js — point d'entrée client (Router + données préchargées OG)
import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppContent from "./AppContent";
import { PreloadedDataProvider } from "contexts/PreloadedDataContext";

function App() {
  const preloadedData =
    typeof window !== "undefined" && window.__INITIAL_DATA__
      ? window.__INITIAL_DATA__
      : {};

  if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual";
  }

  return (
    <Router>
      <PreloadedDataProvider data={preloadedData}>
        <AppContent />
      </PreloadedDataProvider>
    </Router>
  );
}

export default App;
